const { apiBasePath } = require("../../views/Constant");

// AES-GCM encryption parameters
const ENCRYPTION = {
  algorithm: "AES-GCM",
  keyLengthBits: 128, // Use 128-bit keys (16 bytes) - supported by all browsers
  ivLengthBytes: 12, // Standard for AES-GCM
  textEncoding: "utf-8",
};

// API configuration
const API = {
  baseUrl: apiBasePath.endsWith("/") ? apiBasePath : `${apiBasePath}/`,
  secureMessageBase: `${apiBasePath}secure-message/`,
};

// Socket configuration
const SOCKET = {
  // Derive socket base from API base URL
  baseUrl: apiBasePath.replace("/api/", "").replace(/\/$/, ""),
  namespace: "/secure-messaging", // Use namespace instead of path
};

// IndexedDB storage keys
const STORAGE_KEYS = {
  userMasterKey: "secure:userMasterKey",
  sessionKeyPrefix: "secure:sessionKey:",
  userMetadata: "secure:userMetadata",
};

// Helper to generate session key storage key
const getSessionKeyStorageKey = (chatId) => {
  return `${STORAGE_KEYS.sessionKeyPrefix}${chatId}`;
};

// Cache configuration
const CACHE = {
  // In-memory cache for performance (optional)
  inMemoryMaxAge: 5 * 60 * 1000, // 5 minutes for in-memory cache
  inMemoryMaxSize: 50, // Maximum number of in-memory cached keys

  // IndexedDB storage is permanent until logout (no expiration)
  // Keys are deterministic from backend, so they never change
};

// API endpoints
const ENDPOINTS = {
  initKeys: "init-keys",
  createChat: "chat",
  createGroup: "group",
  getChats: "chats",
  getChatsWithUnreadCount: "chats-with-unread-count",
  getChat: (chatId) => `chat/${chatId}`,
  getMessages: (chatId) => `${chatId}/messages`,
  getDecryptionKey: (chatId) => `key/${chatId}`,
  getUserMasterKey: "user-master-key",
  sendMessage: "send",
  editMessage: (messageId) => `message/${messageId}`,
  deleteMessage: (messageId) => `message/${messageId}`,
  markMessagesRead: "messages/read",
};

// Socket events
const SOCKET_EVENTS = {
  secureMessage: "secure_message",
  messageUpdated: "message_updated",
  messageDeleted: "message_deleted",
  messagesRead: "messages_read",
  secureTyping: "secure_typing",
  keyRotation: "key_rotation", // For future use
};

module.exports = {
  ENCRYPTION,
  API,
  SOCKET,
  STORAGE_KEYS,
  CACHE,
  ENDPOINTS,
  SOCKET_EVENTS,
  getSessionKeyStorageKey,
};
